import React, { useState, useEffect } from 'react';
import { View, Text } from 'react-native';
import { MaterialIcons } from "@expo/vector-icons";
import { BarCodeScanner } from 'expo-barcode-scanner';
import { FormattedMessage } from 'react-intl';

import styles from './styles';

const QrCodeTransferPix = ({ navigation }) => {
    const [hasPermission, setHasPermission] = useState(null);
    const [scanned, setScanned] = useState(false);

    useEffect(() => {
        (async () => {
            const { status } = await BarCodeScanner.requestPermissionsAsync();
            setHasPermission(status === 'granted');
        })();
    }, []);

    const handleBarCodeScanned = ({ type, data }) => {
        setScanned(true);
        navigation.navigate('QrCodeConfirmTransferPix');
    };

    if (hasPermission === null) {
        return <Text><FormattedMessage id='qrCodeTransferPix.txtAcessoCamera'/></Text>;
    }
    if (hasPermission === false) {
        return <Text><FormattedMessage id='qrCodeTransferPix.txtSemAcessoCamera'/></Text>;
    }

    return (
        <View style={styles.container}>
            <MaterialIcons
                name="keyboard-arrow-left"
                size={30}
                color="#fff"
                style={styles.iconBackPage}
                onPress={() => navigation.goBack()}
            />
            
            <Text style={styles.textInfoQrCode}><FormattedMessage id='qrCodeTransferPix.txtAponteLeitorQrCode'/></Text>
            <BarCodeScanner
                onBarCodeScanned={scanned ? undefined : handleBarCodeScanned}
                style={styles.contentQrCode}
            />
        </View>
    );
}

export default QrCodeTransferPix;